import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import {
  SYSTEM_WORKER_COUNT,
  WORK_HOUR_ZONES,
  WORKER_TYPES,
} from '../../../utilities/constants';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

const getOvertimeStart = (earlytimeEnd, tempHour) => {
  const start = new Date(`2016/01/01 ${earlytimeEnd}`);
  const hour = parseFloat(tempHour);
  const end = new Date(start.getTime() - hour * 60 * 60 * 1000);
  return `${`000${end.getHours()}`.slice(-2)}:${`00${end.getMinutes()}`.substr(
    `00${end.getMinutes()}`.length - 2,
    2
  )}`;
};

export const getWorkTime = (workDate, field) => {
  let workHour = '';
  if (_.size(field.work_hour) === 1) {
    workHour = field.work_hour[0];
  } else {
    const sortedWorkHours = _.sortBy(field.work_hour, 'start_date');
    workHour = _.last(
      _.filter(sortedWorkHours, w =>
        moment(w.start_date).isSameOrBefore(workDate)
      )
    );
    if (!workHour) {
      workHour = _.head(
        _.filter(sortedWorkHours, w => moment(w.start_date).isAfter(workDate))
      );
    }
  }
  const workTime = {};
  workTime[WORK_HOUR_ZONES.day.id] = _.assign(
    workTime[WORK_HOUR_ZONES.day.id],
    { start: field.work_start_time }
  ); // 労働開始時刻（昼）
  workTime[WORK_HOUR_ZONES.day.id] = _.assign(
    workTime[WORK_HOUR_ZONES.day.id],
    { end: field.work_end_time }
  ); // 労働終了時刻（昼）
  workTime[WORK_HOUR_ZONES.day.id] = _.assign(
    workTime[WORK_HOUR_ZONES.day.id],
    { working_time: workHour.worker_work_time }
  ); // 作業時間
  workTime[WORK_HOUR_ZONES.day.id] = _.assign(
    workTime[WORK_HOUR_ZONES.day.id],
    {
      earlytime_end: field.earlytime_end
        ? field.earlytime_end.slice(0, -3)
        : '00:00',
    }
  ); // 早出終了時間（昼）
  workTime[WORK_HOUR_ZONES.day.id] = _.assign(
    workTime[WORK_HOUR_ZONES.day.id],
    {
      overtime_start: field.overtime_start
        ? field.overtime_start.slice(0, -3)
        : '00:00',
    }
  ); // 残業開始時間（昼）
  workTime[WORK_HOUR_ZONES.night.id] = _.assign(
    workTime[WORK_HOUR_ZONES.night.id],
    { start: field.work_start_time_night }
  ); // 労働開始時刻（夜）
  workTime[WORK_HOUR_ZONES.night.id] = _.assign(
    workTime[WORK_HOUR_ZONES.night.id],
    { end: field.work_end_time_night }
  ); // 労働終了時刻（夜）
  workTime[WORK_HOUR_ZONES.night.id] = _.assign(
    workTime[WORK_HOUR_ZONES.night.id],
    { working_time: workHour.worker_work_time }
  ); // 作業時間
  workTime[WORK_HOUR_ZONES.night.id] = _.assign(
    workTime[WORK_HOUR_ZONES.night.id],
    {
      earlytime_end: field.earlytime_end_night
        ? field.earlytime_end_night.slice(0, -3)
        : '00:00',
    }
  ); // 早出終了時間（夜）
  workTime[WORK_HOUR_ZONES.night.id] = _.assign(
    workTime[WORK_HOUR_ZONES.night.id],
    {
      overtime_start: field.overtime_start_night
        ? field.overtime_start_night.slice(0, -3)
        : '00:00',
    }
  ); // 残業開始時間（夜）
  workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
    workTime[WORK_HOUR_ZONES.midnight.id],
    { start: field.work_start_time_midnight }
  ); // 労働開始時刻（深夜）
  workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
    workTime[WORK_HOUR_ZONES.midnight.id],
    { end: field.work_end_time_midnight }
  ); // 労働終了時刻（深夜）
  workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
    workTime[WORK_HOUR_ZONES.midnight.id],
    { working_time: workHour.worker_work_time }
  ); // 作業時間
  workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
    workTime[WORK_HOUR_ZONES.midnight.id],
    {
      earlytime_end: field.earlytime_end_midnight
        ? field.earlytime_end_midnight.slice(0, -3)
        : '00:00',
    }
  ); // 早出終了時間（深夜）
  workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
    workTime[WORK_HOUR_ZONES.midnight.id],
    {
      overtime_start: field.overtime_start_midnight
        ? field.overtime_start_midnight.slice(0, -3)
        : '00:00',
    }
  ); // 残業開始時間（深夜）

  return workTime;
};

const WorkEarlyTimesTemplate = ({ context, fieldInfo }) => {
  const { work_date, work_early_times } = context.item;

  let workEarlyTimes = [];

  if (_.isEmpty(work_early_times)) {
    let workHourZone = SessionStorageService.getItem('work_hour_zone');
    const earlyWorkStart = '';
    const overWorkEnd = getWorkTime(work_date, fieldInfo)[workHourZone]
      .earlytime_end;
    const earlyTime = {
      fixed_unfixed_type: WORKER_TYPES.contractor.id,
      working_temp_person: SYSTEM_WORKER_COUNT[0].id,
      working_temp_hour: 0.0,
      overtime_start: earlyWorkStart,
      earlytime_end: overWorkEnd,
    };
    workEarlyTimes = [earlyTime];
  } else {
    _.each(work_early_times, work_early_time => {
      let early = {
        id: work_early_time.id,
        working_temp_person: work_early_time.working_temp_person,
        working_temp_hour: work_early_time.working_temp_hour,
        overtime_start: getOvertimeStart(
          work_early_time.earlytime_end,
          work_early_time.working_temp_hour
        ),
        earlytime_end: work_early_time.earlytime_end.slice(0, -3),
      };
      workEarlyTimes.push(early);
    });
  }

  const items = _.map(workEarlyTimes, (workEarlyTime, index) => {
    const {
      id,
      working_temp_person,
      working_temp_hour,
      overtime_start,
      earlytime_end,
    } = workEarlyTime;
    return (
      <div className='work-day-time' key={id || index}>
        <span className='work-day-time-person'>{working_temp_person} 人</span>
        <span className='work-day-time-cross'>×</span>
        <span className='work-day-time-hour'>
          {Number(working_temp_hour).toFixed(2)} 時間
        </span>
        <span>
          {'作業時刻 '}
          {overtime_start && overtime_start}
          {(overtime_start || earlytime_end) && ' 〜 '}
          {earlytime_end && earlytime_end}
        </span>
      </div>
    );
  });
  return (
    <div
      className={`work-day-cell ${
        _.size(workEarlyTimes) <= 3
          ? 'work-day-times-container'
          : 'work-day-times-container--scroll'
      }`}
    >
      {items}
    </div>
  );
};

export default WorkEarlyTimesTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/WorkEarlyTimesTemplate.jsx